import { render, staticRenderFns } from "./LinkExams.vue?vue&type=template&id=0c1262c3"
import script from "./LinkExams.vue?vue&type=script&lang=js"
export * from "./LinkExams.vue?vue&type=script&lang=js"
import style0 from "./LinkExams.vue?vue&type=style&index=0&id=0c1262c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports